import React from 'react'
import injectSheet from 'react-jss'
import styles from './style'

const BlindSpotCheckbox = ({ classes, showCameraBlindspot, updateUiAction }) => (
  <label className={classes.blindspotLabel}>
    <input
      className={classes.blindspotCheckbox}
      type='checkbox'
      checked={showCameraBlindspot}
      onChange={updateUiAction.bind(null, { showCameraBlindspot: !showCameraBlindspot })}
    /> Show camera blind spot
  </label>
)

export default injectSheet(styles)(BlindSpotCheckbox)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/BlindSpotCheckbox/index.js